document.addEventListener("DOMContentLoaded", function () {
	// Create sticky buttons
	if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
		var sticky_button_container = document.createElement("aside");
		sticky_button_container.classList.add("sticky-buttons");

		var button_containers = document.querySelectorAll(
			".section-hero .wp-block-buttons, .button-modal:not(.trigger-visible-in-content)"
		);
		button_containers.forEach(function (button_container) {
			var buttons = button_container.querySelectorAll(".wp-block-button__link, .dialog-trigger");
			buttons.forEach(function (button) {
				// console.log(button.textContent.trim());

				if (button.tagName === "A") {
					var url = button.href.replace(window.location.origin, "").replace(window.location.pathname, "");
					if (typeof url === "string" && url.startsWith("#")) {
						return;
					}
				}

				var sticky_button = button.cloneNode(true);
				if (sticky_button.hasAttribute("id")) {
					var sticky_button_id = sticky_button.id + "-sticky";
					sticky_button.setAttribute("id", sticky_button_id);
				}

				if (sticky_button.classList.contains("wp-block-button__link")) {
					sticky_button.classList.add("button");
				}

				sticky_button_container.append(sticky_button);
			});
		});

		if (sticky_button_container.children.length > 0) {
			document.body.append(sticky_button_container);

			// Show/hide the buttons based on the header, hero, forms and footer
			let buttonObserver = new IntersectionObserver(
				function (entries, observer) {
					var anyAreIntersecting = false;
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							anyAreIntersecting = true;
						}
					});
					if (anyAreIntersecting) {
						sticky_button_container.classList.remove("is-sticky");
					} else {
						sticky_button_container.classList.add("is-sticky");
					}
				},
				{ threshold: 0.5 }
			);
			document.querySelectorAll(".section-hero, .gform_wrapper, .site-footer").forEach(function (element) {
				buttonObserver.observe(element);
			});
		}
	}
});
